<template>
  <div class="main">
    <div>
      <div>
        <Empty class="custom" :image="icon">
          <div class="msg">该内容已失效，看看其他内容吧~</div>
        </Empty>
      </div>
    </div>
  </div>
</template>
<script>
import { Empty } from "vant";
export default {
  components: { Empty },
  data() {
    return {
      icon: require('./img/404.png')
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {}
  }
};
</script>
<style lang="less" scoped>
.custom{
  .msg{
    color: #666;
    font-size: .15rem;
  }

  /deep/ .van-empty__image{
    width: 2.8rem;
    height: 2.15rem;
  }
}

</style>
